const COMMENT_PATTERN = /(\/\/|#).*$/;

export function sanitizePlain(input) {
  if (input == null) return '';
  const text = String(input);
  // Keep newlines and basic whitespace, strip other control chars.
  let cleaned = '';
  for (const char of text) {
    const code = char.codePointAt(0);
    if (code === undefined) {
      continue;
    }
    if ((code >= 0x20 || code === 0x09 || code === 0x0a || code === 0x0d) && code !== 0x7f) {
      cleaned += char;
    }
  }
  return cleaned;
}

export function toHalfWidth(input) {
  if (input == null) return '';
  return String(input)
    .replace(/[！-～]/g, (ch) => String.fromCharCode(ch.charCodeAt(0) - 0xfee0))
    .replace(/　/g, ' ')
    .replace(/[．。]/g, '.')
    .replace(/[，、]/g, ',')
    .replace(/[×✕✖✖︎]/g, 'x');
}

function normalizeNumericToken(token) {
  const normalized = toHalfWidth(token)
    .replace(/[,\s]+/g, '')
    .replace(/^[+]/, '');
  if (!normalized) return null;
  const value = Number(normalized);
  return Number.isFinite(value) ? value : null;
}

export function parseLine(rawLine) {
  if (rawLine == null) return null;
  const sanitized = sanitizePlain(rawLine);
  const normalized = toHalfWidth(sanitized);
  const withoutComment = normalized.replace(COMMENT_PATTERN, '').trim();
  if (!withoutComment) return null;

  const mulMatch = withoutComment.match(/(-?\d[\d,.]*)\s*[x*]\s*(-?\d[\d,.]*)/i);
  if (mulMatch) {
    const base = normalizeNumericToken(mulMatch[1]);
    const mult = normalizeNumericToken(mulMatch[2]);
    if (base != null && mult != null) {
      return { base, mult, value: base * mult };
    }
  }

  const singleMatch = withoutComment.match(/^(-?\d[\d,.]*)$/);
  if (singleMatch) {
    const base = normalizeNumericToken(singleMatch[1]);
    if (base != null) {
      return { base, mult: 1, value: base };
    }
  }

  return null;
}

export function summarize(text) {
  const sanitized = sanitizePlain(text);
  const lines = sanitized.split(/\r?\n/);
  const items = [];
  const details = [];
  let total = 0;
  lines.forEach((line, index) => {
    const parsed = parseLine(line);
    if (parsed) {
      total += parsed.value;
      items.push({ index: index + 1, raw: line, ...parsed });
      details.push({ index: index + 1, raw: line, value: parsed.value });
    } else {
      details.push({ index: index + 1, raw: line, value: null });
    }
  });
  return { total, items, details, lines };
}
